import { render, staticRenderFns } from "./PathDown.vue?vue&type=template&id=45e17fb7&scoped=true&"
import script from "./PathDown.vue?vue&type=script&lang=js&"
export * from "./PathDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e17fb7",
  null
  
)

export default component.exports